<template>
<div class="chapter">
<div class="inner_page">
<p><a id="p01"></a></p>
<div class="ct"><img alt="003" class="imgepub" src="davi_9781571318398_oeb_003_r1.gif"/> <b>In the Thick of It</b></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// davi_9781571318398_oeb_p01_r1.vue?5d152e9a